import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Spinner, Badge } from 'react-bootstrap';
import {Link} from 'react-router-dom';
import { ArrowLeft, Edit, Plus, Trash, X } from 'react-feather';
import Sidebar from './sidebar';
import api from "../api";
import { FaClipboardCheck, FaToggleOff, FaToggleOn } from 'react-icons/fa';

function EmployeeManagement() {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem("access_token");
    const [employees, setEmployees] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [DelId, setDelId] = useState("");
    const [DelIdStatus, setDelIdStatus] = useState(false);
    const [form, setForm] = useState({
    name: '', email: '', role: '', rights: []
    });
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingEmployee, setEditingEmployee] = useState(null);
    

    const rightsOptions = ['Stock', 'Orders', 'Customers', 'Reports', 'Pos', 'Staff', 'Account Management', 'Finance'];

    useEffect(() => {
        fetchEmployees();
    }, []);

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            const res = await api.get(baseUrl+'/employees/', {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  Authorization: `Bearer ${token}`,
                },
              });
            setEmployees(res.data.results);
        } catch (err) {
            setErrorMsg('Failed to load employees');
        }
        setLoading(false);
    };

    const handleDelete = async (id) => {
        setErrorMsg();
        setSuccessMsg();
        try {
            await api.delete(baseUrl+`/employees/${id}/`, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  Authorization: `Bearer ${token}`,
                },
              });
            setSuccessMsg('Employee removed');
            setDelIdStatus(true);
            fetchEmployees();
        } catch {
            setErrorMsg('Failed to remove employee');
        }
    };

    const handleAdd = async (e) => {
        setLoading(true);
        setErrorMsg('');
        setSuccessMsg('');
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', form.name);
        formData.append('email', form.email);
        formData.append('role', form.role);
      
        form.rights.forEach((right) => {
          formData.append('rights', right); // Important: no 'rights[]' — just 'rights'
        });
      
        try {
          await api.post(baseUrl + '/employees/', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token}`,
            },
          });
          setSuccessMsg('Employee added successfully. Invite Email Sent.');
          setLoading(false);
          setForm({ name: '', email: '', role: '', rights: [] });
          fetchEmployees();
          setTimeout(() => {
            setShowAddModal(false);
            setLoading(false);
            setErrorMsg('');
            setSuccessMsg('');
        }, 3000);
        } catch (err) {
          setLoading(false);
          setErrorMsg('Failed to add employee. kindly check for empty fields.');
        }
    };
      

    const toggleRight = (right) => {
        setForm(prev => ({
            ...prev,
            rights: prev.rights.includes(right)
            ? prev.rights.filter(r => r !== right)
            : [...prev.rights, right]
        }));
    };

    function deleteStepOne(product){
        setDelId(product);
        setDelIdStatus(false);
    }

    const handleEditClick = (emp) => {
        setEditingEmployee(emp);
        setForm({
          name: emp.name,
          email: emp.email,
          role: emp.role,
          rights: emp.rights,
        });
        setShowEditModal(true);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMsg('');
        setSuccessMsg('');
      
        const payload = {
            name: form.name,
            email: form.email,
            role: form.role,
            rights: form.rights,  // stays as an array
        };
      
        try {
            await api.patch(`${baseUrl}/employees/${editingEmployee.id}/`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            setSuccessMsg('Employee updated successfully.');
            fetchEmployees();            
            setTimeout(() => {
                setShowEditModal(false);
                setEditingEmployee(null);
          }, 3000);
        } catch (err) {
          setErrorMsg('Failed to update employee.');
        } finally {
          setLoading(false);
        }
    };
      

      
  return (
          <section className="container mtopcon dashb">
              <div className="row">
                  <div className="col-12 col-lg-2 dash-min mb-3">
                          <div className="nav-left-sidebar sidebar-dark pc">
                              <div className="slimScrollDiv" ><div className="menu-list" >
                                  <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                      <a className="d-xl-none d-lg-none" href="#"></a>
                                      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                          <span className="navbar-toggler-icon"></span>
                                      </button>
                                      <div className="collapse navbar-collapse" id="navbarNav">
                                          <Sidebar/>
                                      </div>
                                  </nav>
                              </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                          </div>
                      </div>
                      <div className="col-12 col-lg-10 dash-max">
                          
                          <div className="row mb-3 ph-header-con">
                            <div className="col-7 pt-2"><h6 className="pageheader-title mb-3">Employees</h6></div>
                            <div className="col-5"><button onClick={() => setShowAddModal(true)} className="btn btn-primary f85 float-right"><Plus/> Add</button></div>
                          </div>
                          <div className="row d-flex justify-content-center">
                              <div className="col-12 col-lg-6">                       
                                    <>
                                            {loading ? <Spinner animation="border" /> : (
                                                <>
                                                    {employees.map(emp => (
                                                        <div className="row ord-bg bg-white staffpadding hvr bx-shadow" key={emp.id}>
                                                                <div className="col-9 col-lg-10 pl-0 pr-0">
                                                                    <div className="row">
                                                                        <div className="col-6 col-lg-6 ord-sz">{emp.name}</div>
                                                                        <div className="col-6 col-lg-6 ord-sz">Role: {emp.role}</div>
                                                                        <div className="col-12 col-lg-12 ord-sz grey-text font8"><FaClipboardCheck/>: {emp.rights.join(', ')}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-3 col-lg-2 f8 text-black prodedtbtn text-right p-0 mt-1 lh34"> 
                                                                    <Button className='me-2' size="sm" variant="secondary" onClick={() => handleEditClick(emp)}><Edit/></Button>
                                                                    <Button size="sm" variant="danger" data-bs-toggle="modal" data-bs-target="#confirmdelModal" onClick={()=>deleteStepOne(emp.id)}><Trash/></Button>                                                                                                                                                 
                                                                </div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}

                                            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title className="font9 font-bold">Add New Employee</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <Form onSubmit={handleAdd}>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label className="font8 mb-1">Name</Form.Label>
                                                                
                                                                <div className="input-group mb-3">
                                                                <span className="input-group-text" id="basic-addon1">@</span>
                                                                <Form.Control value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
                                                                </div>
                                                            </Form.Group>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label className="font8 mb-1">Email</Form.Label>
                                                                <Form.Control type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
                                                            </Form.Group>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label className="font8 mb-1">Role</Form.Label>
                                                                <Form.Control value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} required />
                                                            </Form.Group>
                                                            <Form.Group>
                                                                <Form.Label className="font8 mb-1">Rights</Form.Label>
                                                                {rightsOptions.map((right, i) => (
                                                                    <Form.Check
                                                                        key={i}
                                                                        type="checkbox"
                                                                        label={right}
                                                                        checked={form.rights.includes(right)}
                                                                        onChange={() => toggleRight(right)}
                                                                    />
                                                                ))}
                                                            </Form.Group>                                 
                                                            {successMsg && <p className="text-success text-center mt-2 mb-2 font9 mb-0"><b>{successMsg}</b></p> } 
                                                            {errorMsg && <p className="text-danger text-center mt-2 mb-2 font9 mb-0"><b>{errorMsg}</b></p> } 
                                                            <Button className="mt-3 col-12" type="submit">{ loading === true ? <><Spinner animation="border" /></> : <>Add</>}</Button>                           
                                                    </Form>
                                                </Modal.Body>
                                            </Modal>

                                            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Edit Employee</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <Form onSubmit={handleEditSubmit}>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Name</Form.Label>
                                                        <Form.Control
                                                        value={form.name}
                                                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                                                        required
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Email</Form.Label>
                                                        <Form.Control
                                                        type="email"
                                                        value={form.email}
                                                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                                                        required
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Role</Form.Label>
                                                        <Form.Control
                                                        value={form.role}
                                                        onChange={(e) => setForm({ ...form, role: e.target.value })}
                                                        required
                                                        />
                                                    </Form.Group>
                                                    <Form.Group>
                                                        <Form.Label>Rights</Form.Label>
                                                        {rightsOptions.map((right, i) => (
                                                        <Form.Check
                                                            key={i}
                                                            type="checkbox"
                                                            label={right}
                                                            checked={form.rights.includes(right)}
                                                            onChange={() => toggleRight(right)}
                                                        />
                                                        ))}
                                                    </Form.Group>
                                                    {successMsg && <p className="text-success mt-2">{successMsg}</p>}
                                                    {errorMsg && <p className="text-danger mt-2">{errorMsg}</p>}
                                                    <Button className="mt-3 w-100" type="submit">
                                                        {loading ? <Spinner animation="border" size="sm" /> : 'Update'}
                                                    </Button>
                                                    </Form>
                                                </Modal.Body>
                                            </Modal>

                                    </>
                              </div>
                          </div>
                  </div>
              </div>

              
            <div className="modal fade" id="confirmdelModal" tabIndex="-1" aria-labelledby="confirmdelModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                    <div className="modal-header p-2">
                        <h1 className="modal-title fs-5" id="confirmdelModalLabel">Confirm</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body text-center">
                        {DelIdStatus==true && <>Employee Removed Successfully</>}
                        {DelIdStatus==false && <>Are you sure you want to remove this employee?</>}                        
                    </div>
                    <div className="modal-footer p-2">                      
                        {DelIdStatus==true && <><button type="button" className="btn btn-primary" data-bs-dismiss="modal">Close</button></>}
                        {DelIdStatus==false && <><button type="button" className="btn btn-danger" onClick={() => handleDelete(DelId)}>Proceed</button></>}
                        
                    </div>
                    </div>
                </div>
            </div>

          </section>
    );
}

export default EmployeeManagement;
